import {
  SET_REPORT_VALUE,
} from '../constants/reportView';

export const setValue = (payload) => ({
  type: SET_REPORT_VALUE,
  payload
});